import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "touristpurpose",
  inputs: [
    {
      name: "starting_date",
      label: "Your journey begins on",
      placeholder: "1 March 2023",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "ending_date",
      label: "Your journey ends on",
      placeholder: "31 March 2023",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },

    {
      name: "purpose",
      label: "For what purpose you are travelling ?",
      placeholder: "For vaccation",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 200,
    },

    {
      name: "country",
      label: "Country",
      placeholder: "Australia",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },

    {
      name: "additional_information",
      label: "Provide more information related to your purpose",
      placeholder: "want to explore Torronto,Quebec",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 400,
    },
    {
      label: "Do you have any sponsoring person ?",
      type: InputType.InputCluster,
      cols: 2,
      fields: [
        {
          name: "sponsoring_person_name",
          label: "Sponsoring Person Name",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
        {
          name: "sponsoring_person_relation",
          label: "Your relation with the person who is Sponsoring you.",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
        {
          name: "sponsoring_person_address",
          label: " Address of a Sponsoring person",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
      ],
    },
    {
      name: "documents_provided",
      label:
        "Name the Legal documents provided by you, which supports your travel",
      placeholder: "",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 400,
    },
  ],
};

export default formFields;
